import React from "react";
import { gettext } from "../../../shared/utils/legacy";

const NavBarTrial = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return (
    <li className="c-navbar__nav-item c-navbar__nav-item-trial">
      <button className="c-btn c-btn--primary c-btn--sm" id="activate_trial_subscription">
        {gettext("Activate trial subscription")}
      </button>
    </li>
  );
};

export default NavBarTrial;
